import React, { useState, useEffect } from 'react';
import apiClient from '../../api/axiosConfig'; // استدعاء خدمتنا
import './LatestJobs.css';
import { IoChevronBackOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';

const LatestJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestJobs = async () => {
      setLoading(true);
      setError(null);
      try {
        // ==== تم تعديل هذا السطر ليطلب 4 وظائف فقط ====
        // استدعاء الـ Endpoint الرئيسي مع إضافة باراميتر limit=4
        const response = await apiClient.get('/jobs', {
          params: {
            limit: 4
          }
        });

        // التأكد من أن البيانات هي مصفوفة قبل تعيينها
        if (Array.isArray(response.data.data)) {
          setJobs(response.data.data);
        } else {
          setJobs([]); // تعيين مصفوفة فارغة في حالة عدم وجود بيانات
        }

      } catch (err) {
        console.error("Error fetching latest jobs:", err);
        setError("فشل تحميل أحدث الوظائف.");
      } finally {
        setLoading(false);
      }
    };

    fetchLatestJobs();
  }, []); // يعمل مرة واحدة فقط عند تحميل المكون

  // عرض رسالة التحميل
  if (loading) {
    return (
        <section className="latest-jobs-section" dir='rtl'>
          <div className="container">
            <h2>أحدث الوظائف</h2>
            <div className="title-line"></div>
            <p>جاري تحميل...</p>
          </div>
        </section>
    );
  }

  // عرض رسالة الخطأ
  if (error) {
    return (
        <section className="latest-jobs-section" dir='rtl'>
          <div className="container">
            <h2>أحدث الوظائف</h2>
            <div className="title-line"></div>
            <p className="text-danger">{error}</p>
          </div>
        </section>
    );
  }

  return (
      <section className="latest-jobs-section" dir='rtl'>
        <div className="container">
          <h2>أحدث الوظائف</h2>
          <div className="title-line"></div>
          <div className="row" id="jobCardsContainer">
            {jobs.length > 0 ? (
                jobs.map((job) => (
                    <div className="col-lg-6" key={job.id}>
                      <div className="jobCard">
                        <img
                            src={job.image_url || require('../../assets/jobdimage.jpeg')}
                            alt={job.title}
                            className="img-fluid job-img"
                        />
                        <div className="job-details">
                          <h5 className="job-title">{job.title}</h5>
                          <p>{job.short_description}</p>
                          <Link to={`/details/${job.id}`} className="read-details">
                            اقرأ التفاصيل
                            <IoChevronBackOutline />
                          </Link>
                        </div>
                      </div>
                    </div>
                ))
            ) : (
                <div className="col-12">
                  <p>لا توجد وظائف متاحة حالياً.</p>
                </div>
            )}
          </div>

          {/* لا يوجد Pagination هنا، وهو المطلوب */}
        </div>
      </section>
  );
};

export default LatestJobs;